import {
	ViewportScale,
	ViewportOperatorOptions,
	ViewportState,
} from "./useViewport.types";

export class ViewportOperand implements ViewportState {
	private _scale: number;
	private _operator: ViewportOperatorOptions;

	constructor(scale: number, operator: ViewportOperatorOptions) {
		this._scale = scale;
		this._operator = operator;
	}

	get xs(): boolean {
		return this._switch(ViewportScale.xs);
	}

	get sm(): boolean {
		return this._switch(ViewportScale.sm);
	}

	get md(): boolean {
		return this._switch(ViewportScale.md);
	}

	get lg(): boolean {
		return this._switch(ViewportScale.lg);
	}

	get xl(): boolean {
		return this._switch(ViewportScale.xl);
	}

	get xxl(): boolean {
		return this._switch(ViewportScale.xxl);
	}

	private _switch(compareScale: number) {
		switch (this._operator) {
			case "greaterThan":
				return this._scale >= compareScale;
			case "lessThan":
				return this._scale < compareScale;
			default:
				return this._scale === compareScale;
		}
	}
}
